export const useToken = (token: string) => {
  return `Bearer ${token}`
}

export const checkStatus = (res: Response) => {
  return res.ok
}

export enum DeviceType {
  USER = 0,
  SHARED = 1,
  PUBLIC = 2
}

// Keep legacy name for backward compatibility with this.$api.deviceType
export const deviceType = DeviceType

export const ContentType = {
  JSON: 'application/json',
  CSV: 'text/csv',
  EVENT_STREAM: 'text/event-stream'
} as const

export const HTTPMode = {
  CORS: 'cors'
} as const

export const CachePolicy = {
  NoStore: 'no-store'
} as const

export const HTTPMethods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const

export enum HTTPStatus {
  OK = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  NotAcceptable = 406,
  Conflict = 409,
  UnprocessableEntity = 422,
  InternalServerError = 500
}

export const PATH_PARAMS = {
  ACCOUNT_ID: 'accountId',
  USER_ID: 'userId'
} as const
